/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type CitationType = (typeof CitationType)[keyof typeof CitationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CitationType = {
	DischargeSummary: 'DischargeSummary',
	LabPanel: 'LabPanel',
	Vitals: 'Vitals',
	OfficeVisit: 'OfficeVisit',
} as const;
